import { useEffect, useState } from 'react';
import httpInstance from '../httpInstance';

const useMappedProviders = (providers) => {
  const [providersRows, setProvidersRows] = useState([]);

  const getProviderById = async (id, type) => {
    const response = await httpInstance.get(`/service-payment/v1/beneficiaries/${id}/${type}`);
    return response.data?.data[0];
  };

  const createImage = (url) => url ? <img src={url} alt="" width={40} height={40} /> : null;

  useEffect(() => {
    const mapCodes = async () => {
      if (!providers) return;

      const mapped = await Promise.all(
        providers.map(async (provider) => {
          const providerData = await getProviderById(provider.beneficiaryId, provider.serviceType);
          return {
            id: provider.beneficiaryId,
            name: provider.reference,
            icon: createImage(provider.beneficiaryUrlImg),
            category: providerData?.creditorAgent,
            min: provider.minAmount,
            max: provider.maxAmount,
            pay_method: providerData?.supplementaryData?.[0]?.paymentMethod,
            payment: providerData?.supplementaryData?.[0]?.instructedAmount?.hasPartialPayment ? 'Si' : 'No',
            vendor: providerData?.supplementaryData?.[0]?.vendor,
            rawProvider: provider,
            rawDetails: providerData,
          };
        })
      );

      setProvidersRows(mapped);
    };

    mapCodes();
  }, [providers]);

  return providersRows;
};

export default useMappedProviders;
